<template>
	<div class="Ccon">
		<div id="container"></div>
		<!-- <div @click="getVideo" class="btn">生成视频9999{{ videoLoading ? '中' : '生成' }}</div> -->
		 
		<showImg3  :imgList="imgList" v-if="isShow" @close="imgClose"></showImg3>
		<!-- <show-img :imgList="imgList" @close="imgClose" :isShow="isShow"></show-img> -->
		<!-- <show-img2 :images="imgList" :interval="2000" @close="imgClose" v-if="isShow"></show-img2> -->
		
	</div>

</template>

<script>
	// import {LabelCluster} from "m"
	import axios  from "axios"
	import { isFinite } from 'core-js/core/number'
	import showImg3 from '../components/showImg3.vue'
	import showImg from '../components/showImg.vue'
	import showImg2 from "../components/showImg2.vue"
import {
		pointData,imgList
	} from '../utils/tools'
	import { baseUrl,mapKey } from '../utils/api'
	import request from "../utils/request.js"
	
	import Point from "@/assets/point.png"
	export default {
		name: 'index',
		components:{showImg3,showImg,showImg2},
		data() {
			return {
				map: null,isShow:true,imgList:null,isShow:false,
				position: null,cityList:[],markerLabel:null,
				roation: null,allPoint:[],videoLoading:false,
				marker: null,isPlay:false,
				trail: null,pathIndex:0,
				markerData: [],
				markerData2:[],
				trailData: [],
				path: [],pathParam:null,videoUrl:'',
				colorOffset: [],
				center: {
					latitude: 40.040523,
					longitude: 116.273654
				},
				durationTime:6,
				speed:0,
				id:'6a2eb50a3f1a473b2cbd6836',
				// 689bff11189f86d5e18bfc09
				// 68940aa0c3b5c9ccb0282517

			}
		},
		computed:{
			mapZoom(){
				const ranges = [
					{min:0,max:100,level:15},
					{min:100,max:500,level:14},
					{min:500,max:1000,level:13},
					{min:1000,max:3000,level:12},
					{min:3000,max:10000,level:11},
					{min:10000,max:20000,level:10},
					{min:20000,max:50000,level:9},
					{min:50000,max:100000,level:8},
					{min:100000,max:150000,level:7},
					{min:200000,max:300000,level:6},
					{min:300000,max:1000000,level:5},
				]
				let spd = ranges.find(range=>this.speed>=range.min&&this.speed<range.max)
				return spd ? spd.level : 9
			}
		},
		watch: {
			// videoUrl(val) {
			// 	if (val && !this.isPlay) {
			// 		this.backToMiniProgram()
			// 	}
			// },
			// isPlay(val){
			// 	if (val&&!this.videoUrl) {
			// 		this.showLoading()
			// 	}
			// }

		},
		mounted() {
			// this.initMap()
			this.videoUrl =''
			this.getUrlParams()
			// this.getVideo()
		    // this.initPoint()
			
			// setTimeout(()=>{
			// 	this.startMove()
			// },1000)
			
		},
		methods: {
			showLoading(){

			},
			backToMiniProgram() {
				console.log('跳转小程序中间页，携带 videoUrl:', this.videoUrl)
				const url = `/pages/downVideo/downVideo?id=${encodeURIComponent(this.id)}`
				if (window.wx && window.wx.miniProgram) {
					window.wx.miniProgram.navigateTo({ url })
				} else if (window.tt && window.tt.miniProgram) {
					window.tt.miniProgram.navigateTo({ url })
				}
			},
			async getVideo(){
				if (this.videoLoading) return
				this.videoLoading = true
				console.log('生成视频:', this.id)
				try {
					// let url ='http://127.0.0.1:8000/api/task/create-from-track'
					let url ='https://tripmp.com/api/task/create-from-track'
					const res = await request.post(url,{
						// "track_id": "68940aa0c3b5c9ccb0282517",
						"track_id": this.id,
					})
					console.log('视频生成完成:', res)
					if (res.video_url) {
						console.log('视频地址:', res.video_url)
						// videoUrl = "https://tripmp.com/outputs/604d37c8-64e6-4148-a02a-14e0d747fd9c.mp4"
						this.videoUrl = 'https://tripmp.com' + res.video_url
						this.videoLoading = false
						}
				} catch(err) {
					console.error('请求失败:', err)
					alert('视频生成失败，请重试')
				} finally {
					this.videoLoading = false
				}
			},
			// 根据起始点获取路线
			async getLine(){
				let param = this.cityList[this.pathIndex]
				let start = param.startCity.latitude+","+param.startCity.longitude
				let end = param.endCity.latitude+","+param.endCity.longitude
				let baseUrl = "/tencent-map/ws/direction/v1/driving/?"
				let url = `${baseUrl}from=${start}&to=${end}&key=${mapKey}`
				
				
				request(url).then(res=>{
					const consp = res.result.routes[0]
					let route = consp.polyline
					for (var i = 2; i < route.length ; i++){
						route[i] = route[i-2] + route[i]/1000000
					}
					let arr = this.dealPolyline(route)
					
					arr.forEach(i=>{
						this.markerData.push(new TMap.LatLng(i.lat, i.lng))
						this.path.push([i.lat, i.lng])
					})
					this.trailData.push({
						path: this.path,
					})
					
				})
			},
			dealPolyline(coords){
				let point = []
				let len = coords.length
				let index = 0
				let ide = Math.floor(len/100)
				let qwe = ide % 2 === 0 ? ide : ide - 1;
				while(index<len){
					// 增加越界判断，避免 undefined 错误
					if (index + 1 >= len) break;
					
					this.path.push([coords[index], coords[index+1]])
					// let param = {
					// 	latitude:coords[index],
					// 	longitude:coords[index+1]
					// }
					// point.push(param)
					point.push(new TMap.LatLng(coords[index], coords[index+1]))
					if(len<100){
						index+=2
					}else{
						index+=qwe
					}
				}
				
				// this.trailData.push({
				// 	path: this.path,
				// })
				
				return point
				
			},
			addDisPoint(posi){
				let endPoint = [
					{
						id:'end',
						styleId:'end',
						position: new TMap.LatLng(posi.latitude,posi.longitude)
						
						
					}
				]
				this.marker.add(endPoint)
			},
			createBackendVideo() {
				this.videoLoading = true   // 按钮显示"生成视频中"
				axios.post('https://tripmp.com/api/task/create-from-track', { track_id: this.id })
					.then(res => {
						this.videoLoading = false
						const videoUrl = 'https://tripmp.com' + res.data.video_url
						
						window.open(videoUrl)  // 新窗口打开下载/播放
					})
			},
			async getTrack(){
				let id = this.id
				let url = `${baseUrl}/upload_track/getTrack?id=${id}`
				request(url).then(res=>{
					
					let data = res.data[0]
				    this.cityList = JSON.parse(data.path)
					this.initMap()
					this.$nextTick(() => {
						setTimeout(() => {
							this.startMove()
						}, 1000)
					})
				}).catch(err=>{
					this.getTrack()
				})
			},
			getUrlParams(){
				let param = this.$route.query
				this.isPlay = true
				if(param.id){
					this.id = param.id
					this.getTrack()
					
				}else{
					// this.initMap2()
					this.getTrack()
				}
			},
			imgClose(){
				this.isShow = false
				this.pathIndex++
				if(this.pathIndex==this.cityList.length){
					this.setAllpoint()
				}else{
					this.startMove()
				}
				
			},
			initPoint(){
				this.marker = new TMap.MultiMarker({
					id:1,
					map:this.map,
				})
				let styles = {}
				let len = this.cityList.length
				for(let i = 0;i<len;i++){
					let param = this.cityList[i]
					
					styles[`vehicle${i}`]=new TMap.MarkerStyle({
						width: 50,
						height: 50,
						faceTo: "map",
						rotate: 180,
						src: param.vehicleUrl,
					})
				}
				
				this.marker.setStyles(styles)
			},
			async startMove(){
				let len = this.cityList.length
				if(len==this.pathIndex){
					return
				}
				let param = this.cityList[this.pathIndex]
				// this.durationTime = param.duration
				await this.initMarker2(param)
				await this.initLabel(param)
				
				// await this.getLine()
				await this.initPath2()
				await this.initTrail2(param)
				
				// 等待 marker 完全渲染后再开始回放，避免使用默认marker
				await this.$nextTick()
				await new Promise(resolve => setTimeout(resolve, 200))
				
				this.marker.moveAlong({
					vehicle: {
						path: this.markerData,
						duration: this.durationTime*1000
					},
				}, {
					autoRotation: true,
				});
				this.trail.setData(this.trailData); //设置数据
			},
			
			getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
				// 将经纬度转换为弧度
				let toRadians = (degree) => degree * (Math.PI / 180);
				let R = 6371; // 地球半径（单位：千米）

				let dLat = toRadians(lat2 - lat1);
				let dLng = toRadians(lng2 - lng1);
				let a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(toRadians(lat1)) *
					Math.cos(toRadians(lat2)) *
					Math.sin(dLng / 2) *
					Math.sin(dLng / 2);
				let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				return R * c; // 返回千米单位
			},
			calcPathTotal(path) {
				if (path.length < 2) return 0; // 至少需要两个点

				let totalDistance = 0;
				for (let i = 1; i < path.length; i++) {
					let prev = path[i - 1];
					let curr = path[i];
					totalDistance += this.getDistanceBetweenPoints(
						// prev.lat, prev.lng,
						// curr.lat, curr.lng
						prev.latitude, prev.longitude,
						curr.latitude, curr.longitude
						
					);
				}
				let num = totalDistance*1000
				let speed = 0
				speed =Number(num/this.durationTime.toFixed(3))
				console.log("速度"+speed)
				this.speed = speed
				return speed
			},
			getTime(type, duration) {
				let time = new Date().getTime()
				if (type == 'start') {
					return time
				} else {
					return time + duration * 100
				}
			},
			async initTrail2(param) {
				return new Promise((resolve)=>{
					let that = this
					this.trail = new TMap.visualization.Trail({
						pickStyle: function(item) {
							//轨迹图样式映射函数
							return {
								width: 6,
								color: param.lineColor,
							};
						},
						showDuration: Infinity, //动画中轨迹点高亮的持续时间
						playTimes: 1,
						playRate:this.calcPathTotal(param.path),
						enableColorOffset: true
					}).addTo(this.map);
					resolve()
				})
				
			},
			// 初始化标记文本
			async initLabel(param,AIndex){
				return new Promise((resolve)=>{
					let that = this
					let index = this.pathIndex
					let len = param.path.length-1
					let posi = param.path[0]
					let name = param.endCity.name
					if(AIndex){
						index=99
						posi = param.path[len]
					}else{
						name = param.startCity.name
					}
					this.markerLabel = new TMap.MultiLabel({
						id:100+index,
						map:this.map,
						styles:{
							'label':new TMap.LabelStyle({
								color:'#fff',
								size:16,
								backgroundColor:'#00aaff',
								borderWidth:2,
								borderRadius:10,
								borderColor:"#fff",
								padding:'5px 10px',
								offset:{
									x:0,
									y:-50
								},
								
							})
						},
						geometries:[
							{
								id: "label",
								styleId: "label",
								position: new TMap.LatLng(posi.latitude, posi.longitude),
								content:name
							}
						]
					})
					resolve()
				})
			},
			async initPath2() {
				return new Promise((resolve)=>{
					let pointData2 = this.cityList[this.pathIndex].path
					
					// let pointData2 =await this.getLine()
					
					pointData2.forEach((i) => {
						this.markerData.push(new TMap.LatLng(i.latitude, i.longitude))
						this.path.push([i.latitude, i.longitude])
						if (i.speed >= 5.05 && i.speed <= 5.13) {
							this.colorOffset.push(0.99)
						} else if (i.speed <= 5.58 && i.speed >= 5.34) {
							this.colorOffset.push(0.01)
						} else {
							this.colorOffset.push(0.5)
						}
					})
					
					this.trailData.push({
						path: this.path,
					})
					resolve()
				})
			},
			
			async initMarker2(param){
				return new Promise((resolve)=>{
					let that = this
					// console.log("图层"+this.pathIndex)
					let poinLen = param.path.length-1
					this.marker = new TMap.MultiMarker({
						id:this.pathIndex,
						map:this.map,
						styles:{
							"vehicle": new TMap.MarkerStyle({
								width: 50,
								height: 50,
								faceTo: "map",
								rotate: 180,
								src: param.vehicleUrl,
							}),
							"start":new TMap.MarkerStyle({
								width: 30,
								height: 30,
								src:Point,
							}),
							"end":new TMap.MarkerStyle({
								width: 30,
								height: 30,
								src:Point,
							}),
							
						},
						geometries: [{
								id: "vehicle",
								styleId: "vehicle",
								position: new TMap.LatLng(param.path[0].latitude, param.path[0].longitude),
							},
							{
								id: "start",
								styleId: "start",
								position: new TMap.LatLng(param.path[0].latitude, param.path[0].longitude),
							},
							
							
						],
					})
					// this.marker.add({
					// 	id:this.pathIndex,
					// 	styleId:`vehicle${this.pathIndex}`,
					// 	position: new TMap.LatLng(param.path[0].latitude, param.path[0].longitude),
						
					// })
					
					
					this.marker.on('moving', function(e) {
						if (e.vehicle) {
							that.roation = TMap.geometry.computeHeading(
								e.vehicle.passedLatLngs[e.vehicle.passedLatLngs.length - 2],
								e.vehicle.passedLatLngs[e.vehicle.passedLatLngs.length - 1]
							);
							that.position = TMap.geometry.computeDestination(that.marker.getGeometryById(
								'vehicle').position, that.roation, 60);
						}
						this.map.easeTo({
							center: that.position,
							rotation: e.vehicle.angle,
							zoom: that.mapZoom,
							pitch: 50,
						}, {
							duration: 200,
						});
					});
					this.marker.on("move_ended", function() {
						console.log("轨迹播放完毕")
						
						that.markerData = []
						that.path = []
						
						that.marker.remove("vehicle")
						
						let clen  = that.cityList.length
						if(that.pathIndex==clen-1){
							let len = param.path.length
							let endPosi = param.path[len-1]
							if(clen==1){
								that.allPoint.push(param.path[0])
								that.allPoint.push(endPosi)
							}else{
								that.allPoint.push(endPosi)
							}
							
							that.addDisPoint(endPosi)
							that.initLabel(param,true)
							
							if(that.cityList[that.pathIndex].imgList.length==0){
								that.setAllpoint()
							}else{
								setTimeout(()=>{
									that.isShow = true
									that.imgList = that.cityList[that.pathIndex].imgList
								},800)
							}
						}else{
							that.allPoint.push(param.path[0])
							if(that.cityList[that.pathIndex].imgList.length==0){
								that.pathIndex++
								that.startMove()
							}else{
								setTimeout(()=>{
									that.isShow = true
									that.imgList = that.cityList[that.pathIndex].imgList
								},800)
							}
						}
						
					})
					// this.marker.remove("vehicle")
					resolve()
				})
			},
			setAllpoint(){
				let bounds = new TMap.LatLngBounds();
				this.allPoint.forEach(function(geometry) {
					// new TMap.LatLng(posi.latitude,posi.longitude)
				  // let latLng = geometry.position; // TMap.LatLng 对象
				  let latLng = new TMap.LatLng(geometry.latitude,geometry.longitude)
				  bounds.extend(latLng);
				});
				
				// 4. 调用 map.fitBounds，让地图自动调整视野以包含所有点
				this.map.fitBounds(bounds,{
					padding:20
				});
				this.isPlay = false
				this.backToMiniProgram()
			},
			async removePoint(){
				return new Promise((resolve)=>{
					// this.marker.remove([this.pathIndex])
					this.marker.remove(`vehicle${this.pathIndex}`)
					// this.marker.setGeometries([])
					resolve()
				})
				
			},
			initMap2(){
				this.map = new TMap.Map(document.getElementById('container'), {
					zoom: 6, //设置地图缩放级别
					disableDefaultUI: true,
					pitch: 30, //设置俯仰角
					baseMap: {
						type: 'satellite', // 核心：设置为卫星底图
						features: ['base', 'road'] // 显示影像+路网
					}

				});
			},
			initMap() {
				let startPoint = this.cityList[0].startCity
				let center = new TMap.LatLng(startPoint.latitude, startPoint.longitude)
				this.map = new TMap.Map(document.getElementById('container'), {
					center: center,
					zoom: 10,
					disableDefaultUI: true,
					pitch: 30,
					baseMap: {
						type: 'satellite',
						features: ['base', 'road']
					},
					mapStyleId: 'style1'
				});
			}

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.btn {
		position: absolute;
		padding: 10px;
		top: 50px;
		left: 50px;
		background-color: azure;
		z-index: 1000;
		pointer-events: auto;
	}

	/deep/ .rotate-circle {
		display: none;
	}

	/deep/ .tmap-zoom-control {
		display: none;
	}

	.Ccon {
		position: relative;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
	}

	#container {
		width: 100vw;
		height: 110vh;
		position: relative;
	}
</style>